import React, { useId } from 'react';
import { Button, Input } from 'reactstrap';
import { Tooltip } from 'react-tooltip';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import Avatar from 'react-avatar';

const IconButtonWithTooltip = ({plainText, translationId, icon, value=null, text=null, onClick, disabled=false, isLoading=false, type=null, size="lg", color="white", className=null, style, spin}) => {
    const { t } = useTranslation();
    const uniqueId = useId();
    let buttonStyle = undefined

    if (isLoading) {
        return (
            <div className="toolbar-icon">
                <FontAwesomeIcon icon={faSpinner} spin size="2x" />
            </div>
        );
    }

    function invertColor(hexColor) {
        const cleanHex = hexColor.replace('#', ''); // Remove the '#' if present
        const inverted = (0xFFFFFF ^ parseInt(cleanHex, 16)).toString(16).padStart(6, '0');
        return `#${inverted}`;
      }
      

    const renderButton = () => {
        const tooltipProps = {
            'data-tooltip-id': uniqueId,
            'data-tooltip-content': translationId ? t(translationId) : plainText
        };

        if(type === 'IconButton')
            //style = {width: '44px', maxWidth: '40px', minWidth: '40px', minHeight: '38px', marginTop: '0px', marginRight:'0px'}     
            style = {width: '44px', maxWidth: '40px', minWidth: '40px', height: '38px' }     
        if(type === 'Button' && size==="xs")  
            buttonStyle = {width: '34px', maxWidth: '30px', minWidth: '30px', height: '30px', marginTop: '0px', marginRight:'2px'} 


        switch(type){
                case 'IconOnly':
                    return (<FontAwesomeIcon aria-hidden={false} icon={icon} size={size} {...tooltipProps} onClick={onClick} spin={icon === faSpinner || spin} style={style} color={color !== 'white' ? color : undefined} className="icon-only"/> 
                );
            case 'IconButton':
                return (
                    <Button onClick={onClick} className="btn btn-link iconButton" {...tooltipProps} style={style}>
                        <span role="img" aria-label={t(translationId)}>{icon}</span>
                    </Button>
                );
            case 'ButtonPrimary':
                return (
                    <Button onClick={onClick} className={className || "btn-icon"} color="primary" {...tooltipProps}>
                        <FontAwesomeIcon icon={icon} size={size} style={style}/> {text && text}
                    </Button>
                );
            case 'Button':
                return (
                    <Button onClick={onClick} className={!text ? className || "btn-icon" : ""} disabled={disabled} {...tooltipProps} color={color} style={buttonStyle}>
                        <FontAwesomeIcon icon={icon} size={size} style={style}/> {text && text}
                    </Button>
                );
            case 'ButtonWithSize':
                return (
                    <Button color={color} onClick={onClick} className={!text ? className || "btn-icon" : ""} disabled={disabled} {...tooltipProps} size={size} style={style}>
                        <FontAwesomeIcon icon={icon} size={size} style={style}/> {text && text}
                    </Button>
                );
            case 'link':
                return (
                    <Button onClick={onClick} color="link" {...tooltipProps}>
                        <FontAwesomeIcon icon={icon} size={size} style={style}/> {text && text}
                    </Button>
                );
            case 'avatar':
                return (
                    <button 
                        className="toolbar-icon" 
                        onClick={onClick} 
                        disabled={disabled} 
                        aria-label={t(translationId)} 
                        style={{color: !disabled && color, marginTop: '-5px', marginBottom: '-5px'}} 
                        {...tooltipProps}
                    >
                        <Avatar style={{ cursor: "pointer"}} fgColor={invertColor(color)} name={translationId} size={32} round={true} color={color}/> 
                    </button>
                );
            default:
                return (
                    <button 
                        className="toolbar-icon" 
                        onClick={onClick} 
                        disabled={disabled} 
                        aria-label={t(translationId)} 
                        style={{color: !disabled && color}} 
                        {...tooltipProps}
                    >
                        <FontAwesomeIcon icon={icon} size={size} />
                    </button>
                );
        }
    };

    return (
        <>
            {renderButton()}
            <Tooltip id={uniqueId} style={{zIndex: 9999}}/>
        </>
    );
};

export default IconButtonWithTooltip;